<template>
  <CommonDialog
    v-model="popShow"
    :top-pic="topPicSrc"
    :title="$t('common.attention')"
    :show-btn="false"
    :content="$t('loginAndRegister.accountDangerDialog')"
  >
    <template #footer>
      <div class="to_verify_btn_box">
        <div v-show="emailBtnShow" class="to_verify_btn" @click="toVerify('EMAIL')">
          {{ $t('loginAndRegister.verifyEmail') }}
        </div>
        <div
          v-show="phoneBtnShow"
          class="to_verify_btn"
          :class="emailBtnShow && phoneBtnShow && 'phone'"
          @click="toVerify('PHONE')"
        >
          {{ $t('loginAndRegister.verifyPhone') }}
        </div>
      </div>
    </template>
  </CommonDialog>
</template>

<script>
import CommonDialog from '@/components/CommonDialog'
import securityDialogTop from '@/assets/security_dialog_top.png'
export default {
  name: 'LoginSecurityDialog',
  components: { CommonDialog },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    emailBtnShow: {
      type: Boolean,
      default: false
    },
    phoneBtnShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      popShow: false,
      topPicSrc: securityDialogTop
    }
  },
  watch: {
    value(val) {
      this.popShow = val
    },
    popShow(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    toVerify(type) {
      this.$emit('toVerify', type)
      this.popShow = false
    }
  }
}
</script>

<style scoped>
.to_verify_btn_box {
  width: 100%;
  margin-top: 0.24rem;
}

.to_verify_btn {
  display: flex;
  width: 100%;
  padding: 0.13rem 0.24rem;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  border-radius: 0.08rem;
  border: 0.01rem solid #3fbb70;
  color: #3fbb70;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.24rem;
}

.to_verify_btn.phone {
  margin-top: 0.12rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginSecurityDialog.vue